export const DEFAULT_DATEFORMAT = 'DD.MM.YYYY';
export const DEFAULT_TIMEFORMAT = 'HH:mm';
